import { useEffect } from "react";
import { useNotify } from "../../../context/notifications";
import websocketService, { ClienteArcaAvisoPayload } from "../../../services/websocket";

const MOTIVOS: Record<string, string> = {
  no_coincide: "ARCA no confirma el DNI",
  no_encontrado: "ARCA no tiene registrado el DNI",
  sugerencia: "ARCA tiene otro nombre para el DNI",
};

export const textoAvisoArca = (aviso: ClienteArcaAvisoPayload): string => {
  const motivo = MOTIVOS[aviso.arca_estado] || "ARCA no confirma el DNI";
  const reserva = aviso.reserva_id ? ` (reserva #${aviso.reserva_id})` : "";
  return `${motivo} de ${aviso.cliente_nombre}${reserva}. Revisalo en la ficha del cliente.`;
};

/**
 * Avisa en pantalla a quien cargó o editó un cliente cuando ARCA no confirma
 * su documento. La consulta termina un par de segundos después de guardar,
 * con el formulario ya cerrado: sin esto, un DNI mal cargado pasaba en silencio.
 */
export const useAvisosArca = (usuarioEmail?: string | null) => {
  const { notify } = useNotify();

  useEffect(() => {
    if (!usuarioEmail) return undefined;
    return websocketService.onClienteArcaAviso((aviso) => {
      if (aviso.usuario_email !== usuarioEmail) return;
      notify(textoAvisoArca(aviso), { severity: "warning", autoHideDuration: 15000 });
    });
  }, [usuarioEmail, notify]);
};
